/**
 * Card Reducer
 */

import { Actions } from "containers/TransferSubscriptions/store/Actions";
import { isNil } from "lodash";
import { Reducer } from "redux";
import { getTransferSubscriptionFormTranslations } from "root/shared/MultiLanguage";
import {
  IInputProps,
  IRadioGroupProps,
  ISelectItem,
  ISelectProps,
} from "root/store/CajitaStore";
import { ITransferSubscriptionFormProps } from "types/cajita_store";
import { ITransferSubscriptionActionCreator } from "types/transfer_subscription_action_creator";

// tslint:disable-next-line:no-duplicate-string
const documentTypeClass: string[] = ["left", "select-pse"];

const initialState: ITransferSubscriptionFormProps = {
  waitResponse: false,
  openModal: false,
  accountNumber: {
    container: "transfer_subscription",
    value: "",
    classContainer: "inputContainer id-input section",
    valid: false,
    dirty: false,
    classes: ["input"],
    inputPattern: /^\d*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 20,
    },
    attributes: {
      id: "accountNumber",
      type: "text",
    },
  },
  accountType: {
    id: "accountType",
    selected: "01",
    items: [
      {
        value: "01",
      },
      {
        value: "02",
      },
    ],
  },
  bankId: {
    id: "bankId",
    value: "0",
    classes: ["section", "select-pse"],
    inputItems: [],
  },
  citySelect: {
    id: "citySelect",
    value: "01",
    classes: ["select-pse", "input-width"],
    inputItems: [],
  },
  departmentSelect: {
    id: "departmentSelect",
    value: "01",
    classes: ["select-pse", "input-width"],
    inputItems: [],
  },
  documentNumber: {
    container: "transfer_subscription",
    value: "",
    classContainer: "inputContainer reference-pse right id-input",
    valid: false,
    dirty: false,
    classes: ["input"],
    inputPattern: /^\d*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 11,
    },
    attributes: {
      id: "documentNumber",
      type: "text",
    },
  },
  documentType: {
    id: "documentType",
    value: "CC",
    classes: documentTypeClass,
    inputItems: [
      { value: "CC", text: "CC" },
      { value: "NIT", text: "NIT" },
      { value: "CE", text: "CE" },
    ],
  },
  email: {
    container: "transfer_subscription",
    value: "",
    classContainer: "inputContainer email-input-transfer section",
    valid: false,
    dirty: false,
    classes: ["input"],
    inputPattern: /^[a-zA-Z0-9._+-@]*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      isEmail: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/,
      required: true,
      maxLength: 100,
    },
    attributes: {
      id: "email",
      type: "text",
    },
  },
  isTransferSubscriptionAvailable: true,
  isValid: false,
  lastName: {
    container: "transfer_subscription",
    value: "",
    classContainer: "inputContainer reference-input section",
    valid: false,
    dirty: false,
    classes: ["input", "reference-input"],
    inputPattern: /^\w*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 20,
    },
    attributes: {
      id: "lastName",
      type: "text",
    },
  },
  name: {
    container: "transfer_subscription",
    value: "",
    classContainer: "inputContainer reference-input",
    valid: false,
    dirty: false,
    classes: ["input", "reference-input"],
    inputPattern: /^\w*$/,
    presentationPattern: /.{1,}/g,
    separator: "",
    rules: {
      required: true,
      maxLength: 20,
    },
    attributes: {
      id: "name",
      type: "text",
    },
  },
  translation: getTransferSubscriptionFormTranslations(),
};

// tslint:disable-next-line:max-func-body-length
const TransferSubscriptionReducer: Reducer<ITransferSubscriptionFormProps> = (
  state: ITransferSubscriptionFormProps = initialState,
  action: ITransferSubscriptionActionCreator
): ITransferSubscriptionFormProps => {
  let input: IInputProps;
  let select: ISelectProps;
  let radio_group: IRadioGroupProps;
  let selectItems: { id: string; items: ISelectItem[] };

  switch (action.type) {
    case Actions.UPDATE_TRANSFER_SUBSCRIPTION_INPUT:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: input,
      };
    case Actions.WAIT_RESPONSE:
      return {
        ...state,
        waitResponse: true,
      };
    case Actions.NOT_WAIT_RESPONSE:
      return {
        ...state,
        waitResponse: false,
      };
    case Actions.SET_TRANSFER_SUBSCRIPTION_INPUT_DIRTY:
      input = action.input as IInputProps;

      return {
        ...state,
        [input.attributes.id]: {
          ...state[input.attributes.id],
          dirty: true,
        },
      };
    case Actions.UPDATE_SELECT_VALUE:
      select = action.select as ISelectProps;

      return {
        ...state,
        [select.id]: select,
      };
    case Actions.UPDATE_RADIO_GROUP:
      radio_group = action.radioGroup as IRadioGroupProps;

      return {
        ...state,
        [radio_group.id]: radio_group,
      };
    case Actions.SWITCH_TRANSFER_SUBSCRIPTION_VALIDITY:
      return {
        ...state,
        isValid: !state.isValid,
      };
    case Actions.SET_TRANSFER_SUBSCRIPTION_TOKEN:
      return {
        ...state,
        token: action.token,
        secureServiceId: action.secureServiceId,
        secureService: action.secureService,
        openModal: checkToken(
          action.token,
          action.secureServiceId,
          action.secureService
        ),
      };
    case Actions.SET_BANK_LIST_ITEMS:
      selectItems = action.selectItems as { id: string; items: ISelectItem[] };

      return {
        ...state,
        isTransferSubscriptionAvailable: true,
        [selectItems.id]: {
          ...state[selectItems.id],
          inputItems: selectItems.items,
        },
      };
    case Actions.DISABLE_TRANSFER_SUBSCRIPTION_FORM:
      return {
        ...state,
        isTransferSubscriptionAvailable: false,
      };
    case Actions.SET_CONFRONTA_QUESTIONS:
      return {
        ...state,
        questions: action.question,
        questionnaireCode: action.questionnaireCode,
        questionReceived: isNil(action.question),
        message: action.message,
      };
    case Actions.SET_CONFRONTA_ERROR:
      return {
        ...state,
        secureValidationError: action.secureValidationError,
      };
    case Actions.DISABLE_SECURE_VALIDATION_ERROR:
      return {
        ...state,
        secureValidationError: undefined,
      };
    default:
      return state;
  }
};

function checkToken(
  token?: string,
  secureId?: string,
  secureService?: string
): boolean {
  return !isNil(token) && !isNil(secureId) && !isNil(secureService);
}

export { TransferSubscriptionReducer };



// WEBPACK FOOTER //
// ./src/containers/TransferSubscriptions/store/Reducer.tsx